import moment from 'moment';

// Filter options shared by every dashboard v2 KPI widget (CDB-494).
// Limited to the windows /dashboard/v2/performance can return, so Revenue never diverges from the
// chart-backed KPIs. This Week / This Month / Last Month / Custom Range need BE from/to support first.
export const PERIOD_OPTIONS = [
  { label: 'Today', value: 'today', group: 'Daily' },
  { label: 'Yesterday', value: 'yesterday', group: 'Daily' },
  { label: 'Last Week', value: 'last_week', group: 'Weekly' },
  { label: 'Last 30 Days', value: '30d', group: 'Total' },
];

export const PERIOD_GROUPS = ['Daily', 'Weekly', 'Monthly', 'Total'];

/**
 * @param {string} period one of PERIOD_OPTIONS values
 * @param {{from?: string, to?: string}} custom YYYY-MM-DD bounds, used when period === 'custom'
 */
export const getDateRange = (period, custom = {}) => {
  switch (period) {
    case 'today':
      return { from: moment().startOf('day').toDate(), to: moment().endOf('day').toDate() };
    case 'yesterday':
      return {
        from: moment().subtract(1, 'day').startOf('day').toDate(),
        to: moment().subtract(1, 'day').endOf('day').toDate(),
      };
    case 'this_week':
      return { from: moment().startOf('isoWeek').toDate(), to: moment().endOf('day').toDate() };
    case 'last_week':
      return {
        from: moment().subtract(1, 'week').startOf('isoWeek').toDate(),
        to: moment().subtract(1, 'week').endOf('isoWeek').toDate(),
      };
    case 'this_month':
      return { from: moment().startOf('month').toDate(), to: moment().endOf('day').toDate() };
    case 'last_month':
      return {
        from: moment().subtract(1, 'month').startOf('month').toDate(),
        to: moment().subtract(1, 'month').endOf('month').toDate(),
      };
    case '7d':
      return { from: moment().subtract(6, 'days').startOf('day').toDate(), to: moment().endOf('day').toDate() };
    case '30d':
      return { from: moment().subtract(29, 'days').startOf('day').toDate(), to: moment().endOf('day').toDate() };
    case 'custom': {
      const from = custom.from ? moment(custom.from) : moment();
      const to = custom.to ? moment(custom.to) : moment();
      return { from: from.startOf('day').toDate(), to: to.endOf('day').toDate() };
    }
    default:
      return { from: moment().startOf('day').toDate(), to: moment().endOf('day').toDate() };
  }
};

/** Grey caption text showing the exact range a widget is calculated over. */
export const getRangeLabel = (period, custom = {}) => {
  const { from, to } = getDateRange(period, custom);
  const start = moment(from);
  const end = moment(to);
  if (start.isSame(end, 'day')) return start.format('MMM DD, YYYY');
  const sameYear = start.isSame(end, 'year');
  return `${start.format(sameYear ? 'MMM DD' : 'MMM DD, YYYY')} – ${end.format('MMM DD, YYYY')}`;
};

export const formatRange = (from, to) => `${moment(from).format('MMM DD')} – ${moment(to).format('MMM DD, YYYY')}`;

export const RANGE_LABEL_STYLE = { fontWeight: 400, fontSize: 12, color: '#8d949b' };
